export const ADMIN_SEARCH_INDEX = [
  // Dashboard
  {
    id: "dashboard-home",
    label: "Dashboard",
    description: "Admin dashboard overview",
    path: "/admin/home",
    section: "dashboard",
    keywords: [
      "dashboard",
      "home",
      "overview",
      "admin home",
    ],
  },
  {
    id: "dashboard-payout-balance",
    label: "Payout Balance",
    description: "View payout balance on dashboard",
    path: "/admin/home",
    section: "payout-balance",
    keywords: [
      "payout balance",
      "balance",
      "wallet balance",
      "dashboard payout",
    ],
  },
  {
    id: "dashboard-qr-generator",
    label: "QR Generator",
    description: "Generate QR from dashboard",
    path: "/admin/home",
    section: "qr-generator",
    keywords: [
      "qr",
      "qr code",
      "generator",
      "qr generator",
    ],
  },
  {
    id: "dashboard-order-dashboard",
    label: "Order Dashboard",
    description: "Dashboard order metrics",
    path: "/admin/home",
    section: "order-dashboard",
    keywords: [
      "order dashboard",
      "orders dashboard",
      "live orders",
      "order summary",
    ],
  },
  {
    id: "dashboard-order-summary",
    label: "Order Summary",
    description: "See order summary widgets",
    path: "/admin/home",
    section: "order-summary",
    keywords: [
      "order summary",
      "summary",
      "dashboard summary",
    ],
  },
  {
    id: "dashboard-live-orders",
    label: "Live Orders",
    description: "Live orders section",
    path: "/admin/home",
    section: "live-orders",
    keywords: [
      "live order",
      "live orders",
      "current live order",
    ],
  },

  // Clients
  {
    id: "clients-main",
    label: "Clients",
    description: "Client configuration and management",
    path: "/admin/clients",
    section: "clients",
    keywords: [
      "clients",
      "client",
      "client configuration",
      "client details",
    ],
  },
  {
    id: "clients-details",
    label: "Client Details",
    description: "Manage client details",
    path: "/admin/clients",
    section: "details",
    keywords: [
      "client details",
      "details",
      "client info",
      "client information",
    ],
  },
  {
    id: "clients-webhook-subscribe",
    label: "Webhook Subscription",
    description: "Subscribe or manage webhooks",
    path: "/admin/clients",
    section: "webhook-subscribe",
    keywords: [
      "webhook",
      "webhook subscribe",
      "subscription webhook",
    ],
  },
  {
    id: "clients-register-whatsapp",
    label: "Register WhatsApp",
    description: "Register WhatsApp for client",
    path: "/admin/clients",
    section: "register-whatsapp",
    keywords: [
      "register whatsapp",
      "whatsapp registration",
      "register wa",
    ],
  },
  {
    id: "clients-whatsapp-config",
    label: "WhatsApp Configurations",
    description: "Activate, deactivate, and manage WhatsApp",
    path: "/admin/clients",
    section: "whatsapp-configurations",
    keywords: [
      "whatsapp configuration",
      "whatsapp configurations",
      "activate whatsapp",
      "deactivate whatsapp",
      "whatsapp business",
    ],
  },
  {
    id: "clients-subscription",
    label: "Client Subscription",
    description: "Manage client subscriptions",
    path: "/admin/clients",
    section: "subscription",
    keywords: [
      "subscription",
      "client subscription",
      "plan",
    ],
  },
  {
    id: "clients-payment-gateway",
    label: "Payment Gateway",
    description: "Manage payment gateway settings",
    path: "/admin/clients",
    section: "payment-gateway",
    keywords: [
      "payment gateway",
      "gateway",
      "pg",
      "payment config",
    ],
  },
  {
    id: "clients-restaurant-config",
    label: "Restaurant Configurations",
    description: "Manage restaurant configuration",
    path: "/admin/clients",
    section: "restaurant-configurations",
    keywords: [
      "restaurant configuration",
      "restaurant settings",
      "restaurant config",
    ],
  },
  {
    id: "clients-whatsapp-business-profile",
    label: "WhatsApp Business Profile",
    description: "Manage WhatsApp business profile",
    path: "/admin/clients",
    section: "whatsapp-business-profile",
    keywords: [
      "whatsapp business profile",
      "business profile",
      "wa profile",
    ],
  },
  {
    id: "clients-whatsapp-business-details",
    label: "WhatsApp Business Details",
    description: "Manage business details",
    path: "/admin/clients",
    section: "whatsapp-business-details",
    keywords: [
      "whatsapp business details",
      "business details",
      "wa details",
    ],
  },
  {
    id: "clients-onboarding-checklist",
    label: "Onboarding Checklist",
    description: "Client onboarding checklist",
    path: "/admin/clients",
    section: "onboarding-checklist",
    keywords: [
      "onboarding",
      "onboarding checklist",
      "checklist",
    ],
  },
  {
    id: "clients-beneficiary-management",
    label: "Beneficiary Management",
    description: "Manage beneficiary accounts and bank details",
    path: "/admin/clients",
    section: "beneficiary-management",
    keywords: [
      "beneficiary",
      "beneficiary management",
      "bank account",
      "beneficiary bank",
      "bank details",
      "add beneficiary",
      "edit beneficiary",
      "change beneficiary",
    ],
  },
  {
    id: "clients-website-settings",
    label: "Website Settings",
    description: "Configure client website settings",
    path: "/admin/clients",
    section: "website-settings",
    keywords: [
      "website settings",
      "website",
      "site settings",
    ],
  },

  // Orders
  {
    id: "orders-main",
    label: "Orders",
    description: "Orders main page",
    path: "/admin/orders",
    section: "orders",
    keywords: [
      "orders",
      "order",
      "current orders",
      "order history",
      "ordering",
      "client wise order",
      "client-wise order",
    ],
  },
  {
    id: "orders-current",
    label: "Current Orders",
    description: "View current orders",
    path: "/admin/orders",
    section: "current-orders",
    keywords: [
      "current orders",
      "current order",
      "live current orders",
    ],
  },
  {
    id: "orders-history",
    label: "Order History",
    description: "View order history",
    path: "/admin/orders",
    section: "order-history",
    keywords: [
      "order history",
      "history",
      "past orders",
    ],
  },
  {
    id: "orders-client-wise",
    label: "Client-wise Orders",
    description: "Search orders by client",
    path: "/admin/orders",
    section: "client-wise-orders",
    keywords: [
      "client wise order",
      "client-wise order",
      "client orders",
    ],
  },

  // Settlement
  {
    id: "settlement-main",
    label: "Settlements",
    description: "Settlement management",
    path: "/admin/orders/settlement",
    section: "settlements",
    keywords: [
      "settlements",
      "settlement",
      "settlement report",
      "payout",
      "wallet balance",
      "unsettled amount",
      "bank details",
      "upi orders",
      "cash orders",
      "restaurant wise transactions",
      "restaurant-wise transactions",
      "update transaction",
      "analytics",
      "reports",
      "revise",
      "processed",
      "unsuccessful",
      "un-successful",
      "invoices",
    ],
  },
  {
    id: "settlement-report",
    label: "Settlement Report",
    description: "View settlement reports",
    path: "/admin/orders/settlement",
    section: "settlement-report",
    keywords: ["settlement report", "report", "settlement reports"],
  },
  {
    id: "settlement-invoices",
    label: "Settlement Invoices",
    description: "Settlement invoice section",
    path: "/admin/orders/settlement",
    section: "invoices",
    keywords: ["invoice", "invoices", "settlement invoice"],
  },
  {
    id: "settlement-payout",
    label: "Settlement Payout",
    description: "Payout section in settlements",
    path: "/admin/orders/settlement",
    section: "pay-out",
    keywords: ["payout", "pay out", "settlement payout"],
  },
  {
    id: "settlement-wallet-balance",
    label: "Wallet Balance",
    description: "Wallet balance in settlements",
    path: "/admin/orders/settlement",
    section: "wallet-balance",
    keywords: ["wallet balance", "wallet", "balance"],
  },
  {
    id: "settlement-unsettled-amount",
    label: "Unsettled Amount",
    description: "Unsettled amount section",
    path: "/admin/orders/settlement",
    section: "unsettled-amount",
    keywords: ["unsettled amount", "unsettled", "pending settlement"],
  },
  {
    id: "settlement-bank-details",
    label: "Settlement Bank Details",
    description: "Settlement bank details",
    path: "/admin/orders/settlement",
    section: "settlement-bank-details",
    keywords: ["settlement bank details", "bank details", "bank"],
  },
  {
    id: "settlement-upi-orders",
    label: "UPI Orders",
    description: "UPI order section",
    path: "/admin/orders/settlement",
    section: "upi-orders",
    keywords: ["upi orders", "upi", "upi transactions"],
  },
  {
    id: "settlement-cash-orders",
    label: "Cash Orders",
    description: "Cash order section",
    path: "/admin/orders/settlement",
    section: "cash-orders",
    keywords: ["cash orders", "cash", "cod"],
  },
  {
    id: "settlement-unsuccessful",
    label: "Unsuccessful Transactions",
    description: "Unsuccessful settlement entries",
    path: "/admin/orders/settlement",
    section: "unsuccessful",
    keywords: ["unsuccessful", "un-successful", "failed transaction"],
  },
  {
    id: "settlement-processed",
    label: "Processed Transactions",
    description: "Processed settlement entries",
    path: "/admin/orders/settlement",
    section: "processed",
    keywords: ["processed", "processed transaction"],
  },
  {
    id: "settlement-restaurant-wise",
    label: "Restaurant-wise Transactions",
    description: "Transactions by restaurant",
    path: "/admin/orders/settlement",
    section: "restaurant-wise-transactions",
    keywords: [
      "restaurant wise transactions",
      "restaurant-wise transactions",
      "restaurant transactions",
    ],
  },
  {
    id: "settlement-update-transaction",
    label: "Update Transaction",
    description: "Update transaction from settlement page",
    path: "/admin/orders/settlement",
    section: "update-transaction",
    keywords: ["update transaction", "edit transaction", "transaction update"],
  },

  // Catalogue
  {
    id: "catalogue-main",
    label: "Catalogue",
    description: "Manage catalogue items and settings",
    path: "/admin/orders/Catalogue",
    section: "catalogue",
    keywords: [
      "catalogue",
      "catalog",
      "catalogue items",
      "item price",
      "manage items",
      "pricing",
      "availability",
      "printing",
      "update size id",
      "add master category",
      "add printer",
      "stock availability",
      "customization",
    ],
  },
  {
    id: "catalogue-manage-items",
    label: "Manage Items",
    description: "Manage catalogue items",
    path: "/admin/orders/Catalogue",
    section: "manage-items",
    keywords: ["manage items", "items", "catalogue items"],
  },
  {
    id: "catalogue-item-price",
    label: "Item Price",
    description: "Manage item pricing",
    path: "/admin/orders/Catalogue",
    section: "item-price",
    keywords: ["item price", "pricing", "price update"],
  },
  {
    id: "catalogue-availability-printing",
    label: "Availability & Printing",
    description: "Availability and printing settings",
    path: "/admin/orders/Catalogue",
    section: "availability-printing",
    keywords: ["availability", "printing", "availability and printing"],
  },
  {
    id: "catalogue-update-size-id",
    label: "Update Size ID",
    description: "Update item size ID",
    path: "/admin/orders/Catalogue",
    section: "update-size-id",
    keywords: ["update size id", "size id", "size"],
  },
  {
    id: "catalogue-master-category",
    label: "Add Master Category",
    description: "Add master category",
    path: "/admin/orders/Catalogue",
    section: "add-master-category",
    keywords: ["master category", "add category", "category"],
  },
  {
    id: "catalogue-printer",
    label: "Add Printer",
    description: "Add printer for catalogue printing",
    path: "/admin/orders/Catalogue",
    section: "add-printer",
    keywords: ["printer", "add printer", "print setup"],
  },
  {
    id: "catalogue-stock",
    label: "Stock Availability",
    description: "Manage stock availability",
    path: "/admin/orders/Catalogue",
    section: "stock-availability",
    keywords: ["stock availability", "stock", "availability"],
  },
  {
    id: "catalogue-customization",
    label: "Customization",
    description: "Manage item customization",
    path: "/admin/orders/Catalogue",
    section: "customization",
    keywords: ["customization", "customize item", "addons"],
  },

  // Dining
  {
    id: "dining-main",
    label: "Dining",
    description: "Dining and table management",
    path: "/admin/orders/Dinning",
    section: "dining",
    keywords: [
      "dining",
      "dinning",
      "tables",
      "manage tables",
      "print qr",
      "print qr codes",
      "handle dining flow",
      "special offers",
      "download qr code",
      "add tables",
      "delete table",
      "table qr code",
    ],
  },
  {
    id: "dining-manage-tables",
    label: "Manage Tables",
    description: "Create and manage dining tables",
    path: "/admin/orders/Dinning",
    section: "manage-tables",
    keywords: ["manage tables", "tables", "add table", "delete table"],
  },
  {
    id: "dining-qr-codes",
    label: "Table QR Codes",
    description: "Print and download dining QR codes",
    path: "/admin/orders/Dinning",
    section: "table-qr-codes",
    keywords: [
      "table qr code",
      "print qr codes",
      "download qr code",
      "qr table",
    ],
  },
  {
    id: "dining-special-offers",
    label: "Special Offers",
    description: "Manage dining offers",
    path: "/admin/orders/Dinning",
    section: "special-offers",
    keywords: ["special offers", "offers", "dining offer"],
  },

  // POS
  {
    id: "pos-main",
    label: "POS",
    description: "POS settings and order history",
    path: "/admin/orders/Pos",
    section: "pos",
    keywords: [
      "pos",
      "anlook pos",
      "pos order history",
      "pos delivery charges",
      "pos discounts",
      "pos customization",
      "pos payment method",
      "pos receipt printing",
      "pos update delivery charges",
    ],
  },
  {
    id: "pos-order-history",
    label: "POS Order History",
    description: "POS order history",
    path: "/admin/orders/Pos",
    section: "pos-order-history",
    keywords: ["pos order history", "pos history", "anlook pos orders"],
  },
  {
    id: "pos-delivery-charges",
    label: "POS Delivery Charges",
    description: "Manage POS delivery charges",
    path: "/admin/orders/Pos",
    section: "pos-delivery-charges",
    keywords: ["pos delivery charges", "delivery charges", "update delivery charges"],
  },
  {
    id: "pos-discounts",
    label: "POS Discounts",
    description: "Manage POS discounts",
    path: "/admin/orders/Pos",
    section: "pos-discounts",
    keywords: ["pos discounts", "discounts"],
  },
  {
    id: "pos-customization",
    label: "POS Customization",
    description: "Manage POS customization",
    path: "/admin/orders/Pos",
    section: "pos-customization",
    keywords: ["pos customization", "customization"],
  },
  {
    id: "pos-payment-method",
    label: "POS Payment Method",
    description: "Manage POS payment methods",
    path: "/admin/orders/Pos",
    section: "pos-payment-method",
    keywords: ["pos payment method", "payment method"],
  },
  {
    id: "pos-receipt-printing",
    label: "POS Receipt Printing",
    description: "Manage POS receipt printing",
    path: "/admin/orders/Pos",
    section: "pos-receipt-printing",
    keywords: ["pos receipt printing", "receipt printing", "receipt"],
  },

  // POS Orders
  {
    id: "posorders-main",
    label: "POS Orders",
    description: "Manage POS orders and settings",
    path: "/admin/orders/PosOrders",
    section: "pos-orders",
    keywords: [
      "pos orders",
      "order table",
      "search by order id",
      "update payment",
      "payment link",
      "send to dp",
      "refund pay",
      "refund ebuzz",
      "refund easebuzz",
      "request address",
      "order status change",
      "current refunds",
      "easebuzz refunds",
      "easebuzz refund status",
      "settings",
      "restaurant settings",
      "delivery charges",
      "services",
      "discounts",
      "coupon",
      "loyalty points",
      "free items",
      "order charges",
      "order timing",
      "receipt printing",
      "banner",
      "configuration",
    ],
  },
  {
    id: "posorders-order-table",
    label: "Order Table",
    description: "View and manage POS order table",
    path: "/admin/orders/PosOrders",
    section: "order-table",
    keywords: ["order table", "pos order table", "search by order id"],
  },
  {
    id: "posorders-update-payment",
    label: "Update Payment",
    description: "Update order payment",
    path: "/admin/orders/PosOrders",
    section: "update-payment",
    keywords: ["update payment", "payment update", "payment status"],
  },
  {
    id: "posorders-payment-link",
    label: "Payment Link",
    description: "Generate or send payment link",
    path: "/admin/orders/PosOrders",
    section: "payment-link",
    keywords: ["payment link", "send payment link"],
  },
  {
    id: "posorders-send-to-dp",
    label: "Send to DP",
    description: "Send order to delivery partner",
    path: "/admin/orders/PosOrders",
    section: "send-to-dp",
    keywords: ["send to dp", "delivery partner", "assign dp"],
  },
  {
    id: "posorders-refund-pay",
    label: "Refund Pay",
    description: "Refund payment",
    path: "/admin/orders/PosOrders",
    section: "refund-pay",
    keywords: ["refund pay", "refund payment", "refund"],
  },
  {
    id: "posorders-refund-ebuzz",
    label: "Refund Easebuzz",
    description: "Process Easebuzz refund",
    path: "/admin/orders/PosOrders",
    section: "refund-easebuzz",
    keywords: [
      "refund ebuzz",
      "refund easebuzz",
      "easebuzz refund",
      "ebuzz refund",
    ],
  },
  {
    id: "posorders-request-address",
    label: "Request Address",
    description: "Request customer address",
    path: "/admin/orders/PosOrders",
    section: "request-address",
    keywords: ["request address", "address request"],
  },
  {
    id: "posorders-order-status",
    label: "Order Status Changes",
    description: "Change order status",
    path: "/admin/orders/PosOrders",
    section: "order-status-changes",
    keywords: ["order status", "change status", "order status changes"],
  },
  {
    id: "posorders-current-refunds",
    label: "Current Refunds",
    description: "Current refund list",
    path: "/admin/orders/PosOrders",
    section: "current-refunds",
    keywords: ["current refunds", "refunds"],
  },
  {
    id: "posorders-easebuzz-refunds",
    label: "Easebuzz Refunds",
    description: "Easebuzz refund list",
    path: "/admin/orders/PosOrders",
    section: "easebuzz-refunds",
    keywords: ["easebuzz refunds", "refund list", "ebuzz refunds"],
  },
  {
    id: "posorders-easebuzz-status-check",
    label: "Easebuzz Refund Status Check",
    description: "Check refund status",
    path: "/admin/orders/PosOrders",
    section: "easebuzz-refund-status-check",
    keywords: ["refund status", "easebuzz refund status", "status check"],
  },
  {
    id: "posorders-settings",
    label: "POS Order Settings",
    description: "Settings inside POS Orders",
    path: "/admin/orders/PosOrders",
    section: "settings",
    keywords: [
      "settings",
      "restaurant settings",
      "delivery charges",
      "services",
      "discounts",
      "coupon",
      "loyalty points",
      "free items",
      "order charges",
      "order timing",
      "receipt printing",
      "banner",
      "configuration",
    ],
  },

  // Payout
  {
    id: "payout-main",
    label: "Payout",
    description: "Payout report and payment logs",
    path: "/admin/payout",
    section: "payout",
    keywords: [
      "payout",
      "payout report",
      "payment logs",
      "settlement config",
      "settlement configuration",
    ],
  },

  // All Transaction
  {
    id: "all-transaction-main",
    label: "All Transactions",
    description: "Transactions, refunds, and revise mapping",
    path: "/admin/all-transaction",
    section: "all-transactions",
    keywords: [
      "transactions",
      "all transaction",
      "all transactions",
      "refunds",
      "all client revise map",
      "revise map",
      "revise update all client",
    ],
  },

  // UPI report
  {
    id: "upi-main",
    label: "UPI Report",
    description: "Monitor and manage UPI payments",
    path: "/admin/upi-report",
    section: "upi-report",
    keywords: [
      "upi report",
      "upi payments",
      "upi transactions",
      "monitor upi",
      "manage upi",
    ],
  },

  // Logs
  {
    id: "logs-main",
    label: "WhatsApp Campaign Logs",
    description: "Campaign and message logs",
    path: "/admin/logs",
    section: "logs",
    keywords: [
      "whatsapp campaign logs",
      "sent logs",
      "received logs",
      "delivered logs",
      "failed logs",
      "accepted logs",
      "responded logs",
      "campaign logs",
      "logs",
    ],
  },

  // WhatsApp
  {
    id: "whatsapp-main",
    label: "WhatsApp Campaigns",
    description: "Manage campaigns, templates, and logs",
    path: "/admin/WhatsApp",
    section: "whatsapp",
    keywords: [
      "whatsapp",
      "campaigns",
      "client wise campaigns",
      "client-wise campaigns",
      "templates",
      "template",
      "view template",
      "delete campaign",
      "logs",
      "campaign view",
    ],
  },

  // Support chat
  {
    id: "support-main",
    label: "Support Chat",
    description: "Support conversations and chat",
    path: "/admin/support/",
    section: "support-chat",
    keywords: [
      "support",
      "support chat",
      "conversation",
      "conversations",
      "chat support",
    ],
  },

  // Support tickets
  {
    id: "support-tickets-main",
    label: "Support Tickets",
    description: "Client tickets and ticket resolution",
    path: "/admin/Support/Tickets",
    section: "support-tickets",
    keywords: [
      "tickets",
      "support tickets",
      "client tickets",
      "complaints",
      "ticket chats",
      "ticket update",
      "ticket resolve",
      "ticket resolution",
    ],
  },

  // Billing
  {
    id: "billing-main",
    label: "Billing",
    description: "Overview of client billing",
    path: "/admin/billing",
    section: "billing",
    keywords: [
      "billing",
      "billing overview",
      "client billing",
      "billing details",
    ],
  },

  // White labels
  {
    id: "white-label-main",
    label: "White Labels",
    description: "Admin white label and top-up management",
    path: "/admin/white-labels",
    section: "white-labels",
    keywords: [
      "white labels",
      "white label",
      "admin white label",
      "top up",
      "top-up",
    ],
  },

  // Chaafo
  {
    id: "chaafo-main",
    label: "Chaafo Domain & Website",
    description: "Manage domains and website creation",
    path: "/admin/chaafo",
    section: "chaafo",
    keywords: [
      "domain creation",
      "domain deletion",
      "check domain",
      "client domain",
      "website creation",
      "chaafo",
      "domain",
      "website",
    ],
  },

  // Super admin
  {
    id: "super-admin-main",
    label: "Super Admin",
    description: "Assignments, entitlement, modules, subscriptions, and plans",
    path: "/admin/supper-admin",
    section: "super-admin",
    keywords: [
      "super admin",
      "supper admin",
      "client assignments",
      "entitlement setting",
      "entitlement deletion",
      "create module",
      "subscription management",
      "plan management",
      "client management",
    ],
  },

  // Recon
  {
    id: "recon-main",
    label: "Settlement Reconciliation",
    description: "Reconciliation for settlements, invoices, and payouts",
    path: "/admin/recon",
    section: "recon",
    keywords: [
      "recon",
      "reconciliation",
      "settlement recon",
      "settlement revise",
      "invoice recon",
      "invoices recon",
      "invoice",
      "payout recon",
      "all orders recon",
      "search by id",
    ],
  },
];